<template>
  <section class="bg-primary text-center py-4 text-white">
    <p class="text-sm">
      Copyright &copy; {{ new Date().getFullYear() }} by <a class="text-white" href="https://yesdok.com">YesDok</a>. All Right Reserved.
    </p>
  </section>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>
